// extracted by mini-css-extract-plugin
module.exports = {"footerLine":"Footer_footerLine__eMpUK","social":"Footer_social__mZOq5","root":"Footer_root__KCK_v"};